import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-input-group-icon',
  templateUrl: './input-group-icon.component.html',
  styleUrls: ['./input-group-icon.component.scss']
})
export class InputGroupIconComponent implements OnInit {
  @Input() prefixIcon: string;
  @Input() suffixIcon: string;
  @Input() suffixIconType: 'NZ_ICON'|'TABLER_ICON' = 'NZ_ICON';
  @Input() prefixIconType: 'NZ_ICON'|'TABLER_ICON' = 'NZ_ICON';
  @Input() size: 'large' | 'small' | 'default' = 'default'

  @Output() suffixClickEvent: EventEmitter<any> = new EventEmitter<any>()
  @Output() prefixClickEvent: EventEmitter<any> = new EventEmitter<any>()
  constructor() { }

  ngOnInit(): void {
  }

  prefixClick($event: MouseEvent) {
    this.prefixClickEvent.emit($event)
  }

  suffixClick($event: MouseEvent) {
    this.suffixClickEvent.emit($event)
  }
}
